import React from 'react'
import styled from 'styled-components/macro'
import { useTranslation } from 'react-i18next'
import { Text, Button, Grid } from '@resultadosdigitais/tangram-components'

const StyledButton = styled(Button)`
  font-size: var(--text-size-sm);
`

const StyledText = styled(Text)`
  font-size: var(--text-size-md);
  margin-bottom: 0px;
  text-align: center;
  @media screen and (min-width: 768px) {
    text-align: end;
  }
`

const StyledGrid = styled(Grid)`
  max-height: 60px;
  max-width: 380px;
  padding: 0px;
  margin-top: var(--size-spacing-05);
  @media (max-width: 768px) {
    margin-bottom: var(--size-spacing-04);
  }
`

const StyledGridRow = styled(Grid.Row)`
  max-height: 28px;
  align-items: center;
`

const StyledGridCol1 = styled(Grid.Column)`
  padding: 0px;
  margin: var(--size-spacing-02) 0;
`
const StyledGridCol2 = styled(Grid.Column)`
  display: flex;
  justify-content: center;
  margin: var(--size-spacing-01) 0;
`

const RedirectToSignup = ({ onRedirect }) => {
  const { t } = useTranslation()

  return (
    <StyledGrid>
      <StyledGridRow align="center" justify="center">
        <StyledGridCol1 smallMobile={12} tablet={6}>
          <StyledText token={Text.tokens.TEXT_MD_REGULAR}>{t('RedirectToSignup.Description')}</StyledText>
        </StyledGridCol1>
        <StyledGridCol2 smallMobile={12} tablet={6}>
          <StyledButton kind={Button.kinds.secondary} type={Button.types.button} size={Button.sizes.sm} onClick={onRedirect}>
            {t('RedirectToSignup.Button')}
          </StyledButton>
        </StyledGridCol2>
      </StyledGridRow>
    </StyledGrid>
  )
}

export default RedirectToSignup
